import React from 'react';
import './App.css';
import {ViewContainer, ViewSelector} from './Containers'
import * as RestApi from "./RestApi"
import {AuthenticationPanel, UpdateAuthButton} from "./Controllers";
import {DownloadAnalyticsButton} from "./Analytics"

export const EAppView = Object.freeze({Sessions: 0, Questions: 1, Zones: 2});
// export const mikaServerEndpoint = "http://127.0.0.1:5000";
export const mikaServerEndpoint = "https://api.itdmlf.it";

global.appKey = "";
global.username = "";
global.password = "";

export function loadAndCheckCredentials() {
    global.appKey = localStorage.getItem("appKey");
    global.username = localStorage.getItem("username");
    global.password = localStorage.getItem("password");
    return (global.appKey && global.username && global.password);
}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {view: EAppView.Sessions, sessions: [], refreshZones: false, refreshQuestions: false, hasAuth: loadAndCheckCredentials()};
        this.changeView = this.changeView.bind(this);
        this.setHasAuth = this.setHasAuth.bind(this);
    }

    changeView(newView) {
        if (newView === EAppView.Sessions) {
            RestApi.getAvailableSessions().then((resp) => {
                if (resp == null) {
                    alert("Errore di comunicazione con il server.");
                } else if (!resp.success) {
                    resp.text().then((txt) => alert(txt));
                }
                this.setState({sessions: (resp.sessions), view: newView, refreshZones: false});
            });
        } else if (newView === EAppView.Zones) {
            this.setState({refreshZones: true, view: newView});
        } else if (newView === EAppView.Questions) {
            this.setState({refreshQuestions: true, view: newView});
        } else {
            this.setState({view: newView, refreshZones: false, refreshQuestions: false});
        }
    }

    setHasAuth(in_hasAuth) {
        this.setState({hasAuth: in_hasAuth})
        if (in_hasAuth) this.changeView(this.state.view);
    }

    componentDidMount() {
        if (!this.state.hasAuth) return;
        this.changeView(EAppView.Sessions);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.refreshZones) {
            this.setState({refreshZones: false});
        }
        if (this.state.refreshQuestions) {
            this.setState({refreshQuestions: false});
        }
    }

    render() {
        const view = this.state.view;

        if (!this.state.hasAuth) {
            return (
                <div className="App_NoCredentials">
                    <AuthenticationPanel onHasAuthChanged={this.setHasAuth}/>
                </div>
            )
        }

        return (
            <div className="App">
                <UpdateAuthButton onHasAuthChanged={this.setHasAuth} changeView={this.changeView}/>
                <DownloadAnalyticsButton/>
                <header className="App-header">
                    <HeaderTitle view={view}/>
                </header>
                <ViewContainer view={view}
                               refreshQuestions={this.state.refreshQuestions}
                               refreshZones={this.state.refreshZones}
                               sessions={this.state.sessions}
                               changeView={this.changeView}/>
                <ViewSelector changeView={this.changeView} view={view}/>
            </div>
        );
    }
}

function

HeaderTitle(props) {
    let header_str = ["Sessioni", "Domande", "Zone"][props.view];
    return <h1>{header_str}</h1>;
}

export default App;
